import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const EightChildrenIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 773.3 200" {...rest} __css={styles}>
      <desc id="svgdescEightChildrenHungerStats">8 children</desc>

      <path
        d="M30.6,44.9c1.6-3.1,3.6-4.6,5.5-5.2c-1.2,2.5-1.9,5.3-1.9,8.2c0,10.5,8.5,19,19,19s19-8.5,19-19
		c0-3-0.7-5.9-2-8.4c2.1,0.5,4.3,1.9,6.1,5.3c3.3,6.6,11.5,4.3,11.5,4.3s-0.7-17.4-10.1-20c-4.6-1.4-8.3,2.3-11,5.4
		c-3.4-3.5-8.2-5.6-13.5-5.6c-5.1,0-9.8,2.1-13.2,5.4c-2.8-3-6.3-6.4-10.9-5.1c-9.4,2.7-10,20-10,20S27.1,51.5,30.6,44.9z"
        fill="#d05800"
      />
      <path
        d="M97.4,103.6L84.2,80.2c-1.3-3.1-6.9-11.5-13.2-11.5H58.4L52.9,85l-5-16.3H36.7c-6.4,0-12,8.4-13.2,11.5
		l-13.3,23.4c-1.7,4.2-0.2,7.1,2.9,8.4c3.5,1.2,7.4-0.5,8.8-3.9l8.6-13.8l-7.3,41.3h14.5c0,0,0,30.1,0.2,31.2
		c0.4,5.7,4.8,9.4,10.8,9.4h10.1c6,0,10.5-3.7,10.9-9.4c0.2-1,0.2-31.3,0.2-31.3h14.5l-7.3-41.2l8.6,13.8c1.4,3.5,5.3,5.2,8.8,4
		C97.6,110.7,99.2,107.8,97.4,103.6z"
        fill="#d05800"
      />
      <circle cx="149.8" cy="47.9" r="19" fill="#002d62" />

      <path
        d="M190.7,103.6L180.3,73c-1.2-2-2.2-4-4.7-4.4h-19L149.7,83L143,68.7h-19c-2.5,0.3-3.5,2.3-4.7,4.4l-10.6,30.5
	c-1.7,4.2-0.1,7,3,8.4c3.5,1.2,7.3-0.5,8.7-3.9l6.2-17.2l-0.3,35.7v0.2h7.9c0,6.7,0,39,0.2,40c0.4,5.7,4.8,9.4,10.8,9.4h10
	c6,0,10.5-3.7,10.9-9.4c0.2-0.9,0.2-33.3,0.2-40h6.8v-0.2l-0.3-35.7l6.2,17.2c1.4,3.5,5.3,5.2,8.8,4
	C190.8,110.7,192.4,107.8,190.7,103.6z"
        fill="#002d62"
      />

      <circle cx="342.4" cy="47.9" r="19" fill="#002d62" />
      <path
        d="M223.2,44.9c1.6-3.1,3.5-4.5,5.4-5.1c-1.2,2.5-1.9,5.2-1.9,8.1c0,10.5,8.5,19,19,19c10.5,0,19-8.5,19-19
		c0-3-0.7-5.8-2-8.3c2.1,0.5,4.3,1.9,6.2,5.3c3.5,6.6,11.5,4.3,11.5,4.3s-0.6-17.4-10-20c-4.7-1.4-8.4,2.3-11.2,5.4
		c-3.4-3.5-8.2-5.7-13.5-5.7c-5.1,0-9.8,2-13.2,5.3c-2.7-3-6.3-6.4-10.8-5c-9.4,2.6-10.1,20-10.1,20S219.8,51.5,223.2,44.9z"
        fill="#002d62"
      />
      <path
        d="M290.1,103.7l-0.1-0.1l-13.3-23.4c-1.2-3.1-6.8-11.5-13.2-11.5H251L245.5,85l-5.1-16.3h-11.2
		c-6.4,0-12,8.4-13.2,11.5l-13.3,23.4c-1.7,4.2-0.2,7.1,3,8.4c3.5,1.2,7.3-0.5,8.7-3.9l8.6-13.8l-7.2,41.3h14.5c0,0,0,30.1,0.2,31.2
		c0.4,5.7,4.8,9.4,10.8,9.4h10c6,0,10.5-3.7,10.9-9.4c0.2-1,0.2-31.3,0.2-31.3h14.5l-7.2-41.1l8.6,13.8c1.4,3.4,5.3,5.1,8.8,3.9
		C290.1,110.8,291.7,107.9,290.1,103.7z"
        fill="#002d62"
      />

      <path
        d="M383.3,103.6L372.8,73c-1.2-2-2.2-4-4.8-4.4h-19L342.5,83l-6.8-14.3h-19c-2.5,0.3-3.5,2.3-4.8,4.4l-10.5,30.5
	c-1.7,4.2-0.1,7.1,3,8.4c3.5,1.2,7.3-0.5,8.7-3.9l6.2-17.2l-0.3,35.7v0.2h7.7c0,6.7,0,39,0.2,40c0.4,5.7,4.8,9.4,10.8,9.4h10.1
	c6,0,10.4-3.7,10.8-9.4c0.2-0.9,0.2-33.3,0.2-40h6.9v-0.2l-0.3-35.7l6.1,17.2c1.4,3.5,5.3,5.2,8.8,4
	C383.4,110.7,385,107.8,383.3,103.6z"
        fill="#002d62"
      />

      <path
        d="M415.7,44.9c1.6-3.1,3.6-4.5,5.5-5.1c-1.2,2.5-1.9,5.2-1.9,8.1c0,10.5,8.5,19,19,19s19-8.5,19-19
		c0-3-0.7-5.9-2-8.4c2.1,0.5,4.4,1.9,6.2,5.4c3.4,6.6,11.5,4.3,11.5,4.3s-0.6-17.4-10-20c-4.7-1.4-8.4,2.3-11.2,5.4
		c-3.4-3.5-8.2-5.7-13.5-5.7c-5.1,0-9.8,2-13.2,5.3c-2.7-3-6.3-6.4-10.8-5c-9.4,2.6-10.1,20-10.1,20S412.3,51.5,415.7,44.9z"
        fill="#002d62"
      />
      <path
        d="M482.6,103.6l-13.3-23.4c-1.2-3.1-6.8-11.5-13.2-11.5h-12.4L438.1,85L433,68.7h-11.3c-6.4,0-12,8.3-13.2,11.4
		l-13.3,23.5c-1.7,4.2-0.2,7,3,8.4c3.5,1.2,7.3-0.6,8.7-4l8.7-13.7l-7.3,41.3h14.5c0,0,0,30.1,0.3,31.2c0.4,5.7,4.8,9.4,10.8,9.4h10
		c6,0,10.4-3.7,10.9-9.4c0.2-1,0.2-31.3,0.2-31.3h14.5l-7.3-41.2l8.6,13.8c1.4,3.4,5.3,5.1,8.8,3.9
		C482.6,110.7,484.2,107.8,482.6,103.6z"
        fill="#002d62"
      />

      <circle cx="535.1" cy="47.9" r="19" fill="#002d62" />
      <path
        d="M575.9,103.6L565.4,73c-1.2-2-2.3-4-4.8-4.4h-19L534.9,83l-6.6-14.3h-19c-2.6,0.3-3.6,2.3-4.8,4.4L494,103.6
	c-1.8,4.2-0.2,7.1,2.9,8.4c3.5,1.2,7.4-0.5,8.8-3.9l6-17.1l-0.3,35.7v0.2h7.9c0,6.9,0,38.9,0.2,39.9c0.4,5.7,4.8,9.4,10.8,9.4h10.1
	c6,0,10.4-3.7,10.8-9.4c0.2-0.9,0.2-33,0.2-39.9h6.9v-0.2L557.9,91l6.2,17.2c1.4,3.4,5.3,5.1,8.8,3.9
	C575.9,110.8,577.5,107.9,575.9,103.6z"
        fill="#002d62"
      />
      <circle cx="722.3" cy="47.9" r="19" fill="#002d62" />
      <path
        d="M763.1,103.6L752.6,73c-1.2-2-2.3-4-4.8-4.4h-19L722.1,83l-6.6-14.3h-19c-2.6,0.3-3.6,2.3-4.8,4.4l-10.5,30.5
	c-1.8,4.2-0.2,7.1,2.9,8.4c3.5,1.2,7.4-0.5,8.8-3.9l6-17.1l-0.3,35.7v0.2h7.9c0,6.9,0,38.9,0.2,39.9c0.4,5.7,4.8,9.4,10.8,9.4h10.1
	c6,0,10.4-3.7,10.8-9.4c0.2-0.9,0.2-33,0.2-39.9h6.9v-0.2L745.1,91l6.2,17.2c1.4,3.4,5.3,5.1,8.8,3.9
	C763.1,110.8,764.7,107.9,763.1,103.6z"
        fill="#002d62"
      />

      <path
        d="M602.8,44.9c2.4-4.5,5.5-5.6,8.1-5.6c-1.7,2.8-2.7,6.1-2.7,9.7c0,10.5,8.5,19,19,19s19-8.5,19-19
		c0-3.3-0.8-6.3-2.3-9c1.6,0.7,3.3,2.2,4.7,4.9c3.4,6.6,11.6,4.3,11.6,4.3s-0.7-17.3-10.1-20c-4.6-1.4-8.1,2.1-10.9,5.1
		c-3.3-2.7-7.5-4.3-12-4.3c-5.4,0-10.2,2.2-13.6,5.8c-2.9-3.2-6.8-8.2-12.2-6.6c-9.4,2.6-10.1,20-10.1,20S599.4,51.5,602.8,44.9z"
        fill="#002d62"
      />
      <path
        d="M669.9,103.6h-0.2l-13.3-23.4c-1.2-3.2-6.7-11.5-13.2-11.5h-12.5L625.2,85l-5-16.3h-11.3
		c-6.4,0-12,8.3-13.2,11.4l-13.3,23.5c-1.7,4.2-0.1,7,3,8.4c3.5,1.2,7.3-0.6,8.7-4l8.7-13.7l-7.3,41.2H610c0,0,0,30.2,0.2,31.3
		c0.4,5.6,4.8,9.3,10.8,9.3h10.2c6,0,10.4-3.7,10.8-9.3c0.2-1.1,0.2-31.3,0.2-31.3h14.6l-7.3-41.2l8.6,13.8c1.4,3.4,5.3,5.1,8.8,3.9
		C669.9,110.7,671.5,107.8,669.9,103.6z"
        fill="#002d62"
      />
    </Icon>
  );
};

export default EightChildrenIcon;
